import React from "react";
import { Navigate } from "react-router-dom";

const lazyWithRetry = (factory) =>
  React.lazy(() =>
    factory().catch((err) => {
      if (err?.name === "ChunkLoadError" || err?.message?.includes("Loading chunk")) {
        window.location.reload();
        return new Promise(() => {});
      }
      throw err;
    })
  );

//Users
const CrmUsers = lazyWithRetry(() => import("../pages/Crm/CrmUsers"));
const UsersInfo = lazyWithRetry(() => import("../pages/Crm/UsersInfo"));
const EmployeesInfo = lazyWithRetry(() => import("../pages/Crm/EmployeesInfo"));

//Companies
const Companies = lazyWithRetry(() => import("../pages/Companies/Companies"));

//Containers
//const Containers = lazyWithRetry(() => import("../pages/Containers/index"));
const Containers = lazyWithRetry(() => import("../pages/Containers/Registration"));
const AdditionalFees = lazyWithRetry(() => import("../pages/AdditionalFees/index"));
const VFCalculation = lazyWithRetry(() => import("../pages/Containers/VFCalculation"));
//const Warehouse = lazyWithRetry(() => import("../pages/Containers/Warehouse"));

const Warehouse = lazyWithRetry(() => import("../pages/Warehouses/index"));
const WarehouseIn = lazyWithRetry(() => import("../pages/Warehouses/WarehouseIn"));
const WarehouseOut = lazyWithRetry(() => import("../pages/Warehouses/WarehouseOut"));
const WarehouseSummary = lazyWithRetry(() => import("../pages/Warehouses/WarehouseSummary"));
const TempWarehouse = lazyWithRetry(() => import("../pages/Warehouses/TempWarehouse"));
const GTAIn = lazyWithRetry(() => import("../pages/Warehouses/GTAIn"));
const GTAOut = lazyWithRetry(() => import("../pages/Warehouses/GTAOut"));
const GTASummary = lazyWithRetry(() => import("../pages/Warehouses/GTASummary"));

//Print Container
const PrintContainer = lazyWithRetry(() => import("../pages/Print/index"));
const PrintVFeesContainer = lazyWithRetry(() => import("../pages/Print/vfees"));
const PrintReceiversContainer = lazyWithRetry(() => import("../pages/Print/receivers"));
const PrintInvoicesContainer = lazyWithRetry(() => import("../pages/Print/invoices"));
const PrintMInvoicesContainer = lazyWithRetry(() => import("../pages/Print/minvoices"));
const PrintWInvoicesContainer = lazyWithRetry(() => import("../pages/Print/winvoices"));
const PrintOrderInvoicesContainer = lazyWithRetry(() => import("../pages/Print/oinvoices"));

//Dashboard
const DashboardContainers = lazyWithRetry(() => import("../pages/DashboardContainers"));
const DashboardOrders = lazyWithRetry(() => import("../pages/DashboardOrders"));

//Report
const Report = lazyWithRetry(() => import("../pages/Report/VFeesStats"));
const Balance = lazyWithRetry(() => import("../pages/Report/Balance"));

//Vehicles
const Vehicles = lazyWithRetry(() => import("../pages/Vehicles"));
const ClientVehicles = lazyWithRetry(() => import("../pages/Vehicles"));

//Orders
const Orders = lazyWithRetry(() => import("../pages/Orders/index"));
const Tracking = lazyWithRetry(() => import("../pages/Orders/indexTracking"));
const OrdersCompanies = lazyWithRetry(() => import("../pages/Orders/OrdersCompanies"));
const Quotes = lazyWithRetry(() => import("../pages/Quotes/index"));
const WebQuotation = lazyWithRetry(() => import("../pages/Quotes/indexWQ"));
const FRTransactions = lazyWithRetry(() => import("../pages/Orders/indexFRTransactions"));
const ClientTracking = lazyWithRetry(() => import("../pages/Orders/indexClient"));

const CustomClearances = lazyWithRetry(() => import("../pages/Invoices/CustomClearances"));
const CustomDeclarations = lazyWithRetry(() => import("../pages/Invoices/CustomDeclarations"));

//Other Logistics
const LContainers = lazyWithRetry(() => import("../pages/Containers/logistics"));
const BrokerReg = lazyWithRetry(() => import("../pages/Containers/BrokerReg"));

//Clients
const ClientContainers = lazyWithRetry(() => import("../pages/Containers/ClientContainers"));
const VFeesStatsClient = lazyWithRetry(() => import("../pages/Report/client"));
const VFBalanceClient = lazyWithRetry(() => import("../pages/Report/BalanceClient"));

//Invoices
const WarehouseInvoices = lazyWithRetry(() => import("../pages/Invoices/WarehouseInvoices"));
const MainInvoices = lazyWithRetry(() => import("../pages/Invoices/MainInvoices"));
const OrderInvoices = lazyWithRetry(() => import("../pages/Invoices/OrderInvoices"));

const Alt404 = lazyWithRetry(() => import("../pages/AuthenticationInner/Errors/Alt404"));

//login
const Login = lazyWithRetry(() => import("../pages/Authentication/Login"));
const Logout = lazyWithRetry(() => import("../pages/Authentication/Logout"));
const ForgetPassword = lazyWithRetry(() => import("../pages/Authentication/ForgetPassword"));
const ResetPassword = lazyWithRetry(() => import("../pages/Authentication/ResetPassword"));

// Landing Index
const OnePage = lazyWithRetry(() => import("../pages/Landing/OnePage"));

//const SimplePage = lazyWithRetry(() => import("../pages/Profile/SimplePage/SimplePage"));
const Settings = lazyWithRetry(() => import("../pages/Profile/Settings/Settings"));

const Documents = lazyWithRetry(() => import("../pages/Documents"));

const Archive = lazyWithRetry(() => import("../pages/Documents/Archive"));

const Requests = lazyWithRetry(() => import("../pages/Requests"));

const ClientsRequests = lazyWithRetry(() => import("../pages/Requests/ClientsRequests"));

const LandingPage = lazyWithRetry(() => import("../pages/LandingPage/index"));
const JobPosts = lazyWithRetry(() => import("../pages/JobPosts/index"));
const NewsPage = lazyWithRetry(() => import("../pages/News/index"));

//Container Logs
const ContainerLogsPage = lazyWithRetry(() => import("../pages/Logs/ContainerLogs"));

export const getAuthProtectedRoutes = () => {
  const user = JSON.parse(localStorage.getItem("authUser"));
  const role = user?.role;
  const type = user?.type;
  const company = user?.company;
  const department = user?.department;
  const section = user?.section;

  if (!user || !user.accessToken) {
    return [
      {
        path: "*",
        component: <Navigate to="/login" />,
      },
    ];
  }

  return [
    //CrmUsers
    ...(role === "Админ" || role === "Гүйцэтгэх захирал"
      ? [{ path: "/users", component: <CrmUsers /> }]
      : [{ path: "/users", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Захиргаа удирдлага, санхүүгийн газрын захирал" ||
      role === "Хүний нөөц, чанарын хэлтсийн дарга"
      ? [{ path: "/employees", component: <EmployeesInfo /> }]
      : [{ path: "/employees", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Захиргаа удирдлага, санхүүгийн газрын захирал" ||
      role === "Хүний нөөц, чанарын хэлтсийн дарга" ||
      role === "Архив, бичиг хэргийн ажилтан"
      ? [{ path: "/documents", component: <Documents /> }]
      : [{ path: "/documents", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Захиргаа удирдлага, санхүүгийн газрын захирал" ||
      role === "Хүний нөөц, чанарын хэлтсийн дарга" ||
      role === "Архив, бичиг хэргийн ажилтан"
      ? [{ path: "/archive", component: <Archive /> }]
      : [{ path: "/archive", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Захиргаа удирдлага, санхүүгийн газрын захирал" ||
      role === "Хүний нөөц, чанарын хэлтсийн дарга" ||
      role === "Архив, бичиг хэргийн ажилтан"
      ? [{ path: "/requests", component: <Requests /> }]
      : [{ path: "/requests", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Кассир" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/dashboard", component: <DashboardContainers /> }]
      : [{ path: "/dashboard", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/dashboard-orders", component: <DashboardOrders /> }]
      : [{ path: "/dashboard-orders", component: <Navigate to="/tracking" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/oinvoices", component: <OrderInvoices /> }]
      : [{ path: "/oinvoices", component: <Navigate to="/tracking" /> }]),

    // ...(role === "Админ" ||
    // role === "Гүйцэтгэх захирал" ||
    // role === "Тээврийн газрын захирал" ||
    // role === "Тээврийн хэлтсийн дарга" ||
    // role === "Тээврийн менежер" ||
    // section === "Санхүүгийн хэлтэс"
    //   ? [{ path: "/oinvoices/:id", component: <PrintOrderInvoicesContainer /> }]
    //   : [{ path: "/oinvoices/:id", component: <Navigate to="/tracking" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/"
      ? [{ path: "/fees", component: <VFCalculation /> }]
      : [{ path: "/fees", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/"
      ? [{ path: "/warehouse", component: <Warehouse /> }]
      : [{ path: "/warehouse", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/warehousein", component: <WarehouseIn /> }]
      : [
        { path: "/warehousein", component: <Navigate to="/user-settings" /> },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/warehouseout", component: <WarehouseOut /> }]
      : [
        {
          path: "/warehouseout",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/warehousereport", component: <WarehouseSummary /> }]
      : [
        {
          path: "/warehousereport",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГТА/"
      ? [{ path: "/tempwarehouse", component: <TempWarehouse /> }]
      : [
        {
          path: "/tempwarehouse",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГТА/"
      ? [
          { path: "/gtain", component: <GTAIn /> },
          { path: "/gtaout", component: <GTAOut /> },
          { path: "/gtasummary", component: <GTASummary /> },
        ]
      : [
          { path: "/gtain", component: <Navigate to="/user-settings" /> },
          { path: "/gtaout", component: <Navigate to="/user-settings" /> },
          { path: "/gtasummary", component: <Navigate to="/user-settings" /> },
        ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/"
      ? [{ path: "/vfreport", component: <Report /> }]
      : [{ path: "/vfreport", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/balance", component: <Balance /> }]
      : [{ path: "/balance", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/invoices", component: <WarehouseInvoices /> }]
      : [{ path: "/invoices", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/minvoices", component: <MainInvoices /> }]
      : [{ path: "/minvoices", component: <Navigate to="/user-settings" /> }]),

    // ...(role === "Админ" ||
    // role === "Гүйцэтгэх захирал" ||
    // role === "Терминалын газрын захирал" ||
    // role === "Товарын хэлтсийн дарга" ||
    // section === "Санхүүгийн хэлтэс" ||
    //   ? [{ path: "/minvoices/:id", component: <PrintMInvoicesContainer /> }]
    //   : [
    //       {
    //         path: "/minvoices/:id",
    //         component: <Navigate to="/user-settings" />,
    //       },
    //     ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      // Аудитор — энэ бол түүний ГАНЦ хуудас, зөвхөн уншина
      role === "Аудитор"
      ? [{ path: "/vehicles", component: <Vehicles /> }]
      : [{ path: "/vehicles", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/companies", component: <Companies /> }]
      : [{ path: "/companies", component: <Navigate to="/containers" /> }]),

    //Reference Information
    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/addfees", component: <AdditionalFees /> }]
      : [{ path: "/addfees", component: <Navigate to="/containers" /> }]),

    //Containers
    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Механик инженер" ||
      role === "Ачаа вагон хүлээлцэгч" ||
      role === "Кранист" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/containers", component: <Containers /> }]
      : [{ path: "/containers", component: <Navigate to="/user-settings" /> }]),

    // ...(role === "Админ" ||
    // role === "Гүйцэтгэх захирал" ||
    // role === "Тээврийн газрын захирал" ||
    // role === "Тээврийн хэлтсийн дарга" ||
    // role === "Тээврийн менежер" ||
    // section === "Санхүүгийн хэлтэс" ||
    //   ? [{ path: "/orders", component: <Orders /> }]
    //   : [{ path: "/orders", component: <Navigate to="/" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/quotes", component: <Quotes /> }]
      : [{ path: "/quotes", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/wquotes", component: <WebQuotation /> }]
      : [{ path: "/wquotes", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/tracking", component: <Tracking /> }]
      : [{ path: "/tracking", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/frtransactions", component: <FRTransactions /> }]
      : [
        {
          path: "/frtransactions",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/lgcompanies", component: <OrdersCompanies /> }]
      : [
        { path: "/lgcompanies", component: <Navigate to="/user-settings" /> },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "Гаалийн брокер" ||
      role === "Талбайн брокер"
      ? [{ path: "/customclearances", component: <CustomClearances /> }]
      : [
        {
          path: "/customclearances",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "Ахлах гаалийн бүртгэгдсэн мэргэжилтэн" ||
      role === "Гаалийн бүртгэгдсэн мэргэжилтэн"
      ? [{ path: "/customdeclarations", component: <CustomDeclarations /> }]
      : [
        {
          path: "/customdeclarations",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" || company === "TILogistic"
      ? [{ path: "/crequests", component: <ClientsRequests /> }]
      : [{ path: "/crequests", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ"
      ? [{ path: "/landing", component: <LandingPage /> }]
      : [{ path: "/settings", component: <Navigate to="/settings" /> }]),

    ...(role === "Админ" || role === "Хүний нөөц, чанарын хэлтсийн дарга"
      ? [{ path: "/jobposts", component: <JobPosts /> }]
      : [{ path: "/jobposts", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" || role === "Хүний нөөц, чанарын хэлтсийн дарга" || role === "Зах зээл, бизнесийн судалгааны мэргэжилтэн"
      ? [{ path: "/news", component: <NewsPage /> }]
      : [{ path: "/news", component: <Navigate to="/user-settings" /> }]),

    //User Profile
    //{ path: "/pages-profile", component: <SimplePage /> },
    { path: "/user-settings", component: <Settings /> },

    // ...(role === "Админ" ||
    // role === "Гүйцэтгэх захирал" ||
    // role === "Тээврийн газрын захирал" ||
    // role === "Тээврийн хэлтсийн дарга" ||
    // role === "Тээврийн менежер" ||
    // section === "Санхүүгийн хэлтэс" ||
    //   ? [{ path: "/lcontainers", component: <LContainers /> }]
    //   : [{ path: "/lcontainers", component: <Navigate to="/" /> }]),

    ...(role === "Админ" ||
      role === "Гаалийн брокер" ||
      role === "Талбайн брокер" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/bcontainers", component: <BrokerReg /> }]
      : [{ path: "/bcontainers", component: <Navigate to="/" /> }]),

    ...(type === "Терминалын газрын хэрэглэгч" ||
      department === "Тээврийн газар"
      ? [{ path: "/client-containers", component: <ClientContainers /> }]
      : [{ path: "/client-containers", component: <Navigate to="/" /> }]),

    ...(type === "Терминалын газрын хэрэглэгч"
      ? [{ path: "/vfclient", component: <VFeesStatsClient /> }]
      : [{ path: "/vfclient", component: <Navigate to="/" /> }]),

    ...(type === "Терминалын газрын хэрэглэгч"
      ? [{ path: "/vfcalc", component: <VFBalanceClient /> }]
      : [{ path: "/vfcalc", component: <Navigate to="/" /> }]),

    ...(type === "Терминалын газрын хэрэглэгч" ||
      department === "Тээврийн газар"
      ? [{ path: "/vhclient", component: <ClientVehicles /> }]
      : [{ path: "/vhclient", component: <Navigate to="/" /> }]),

    ...(type === "Тээврийн газрын хэрэглэгч"
      ? [{ path: "/client-tracking", component: <ClientTracking /> }]
      : [{ path: "/client-tracking", component: <Navigate to="/" /> }]),

    //{ path: "/client-containers", component: <ClientContainers /> },
    //{ path: "/vfclient", component: <VFeesStatsClient /> },
    //{ path: "/vfcalc", component: <VFBalanceClient /> },
    //{ path: "/vhclient", component: <ClientVehicles /> },

    ...(role === "Админ"
      ? [{ path: "/logs", component: <ContainerLogsPage /> }]
      : [{ path: "/logs", component: <Navigate to="/containers" /> }]),

    { path: "/auth-404-alt", component: <Alt404 /> },

    {
      path: "/",
      exact: true,
      component: <Navigate to="/user-settings" />,
    },
    { path: "*", component: <Navigate to="/user-settings" /> },
  ];
};

export const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPassword /> },
  { path: "/reset-password/:token", component: <ResetPassword /> },
  //Print Containers
  { path: "/print/:id", component: <PrintContainer /> },
  { path: "/printvf/:id", component: <PrintVFeesContainer /> },
  { path: "/printrc/:id", component: <PrintReceiversContainer /> },
  { path: "/invoices/:id", component: <PrintInvoicesContainer /> },
  { path: "/minvoices/:id", component: <PrintMInvoicesContainer /> },
  { path: "/oinvoices/:id", component: <PrintOrderInvoicesContainer /> },
  { path: "/winvoices/:id", component: <PrintWInvoicesContainer /> },

];
